import { api } from '@/lib/api'

/**
 * @returns {Promise<import('@/types/api').Product[]>}
 */
export async function fetchInventoryProducts() {
  const { data } = await api.get('/inventory/products')
  return data.data.products
}

/**
 * @returns {Promise<import('@/types/api').StockBalance[]>}
 */
export async function fetchStockBalances() {
  const { data } = await api.get('/inventory/balances')
  return data.data.balances
}

/**
 * @returns {Promise<import('@/types/api').Product[]>}
 */
export async function fetchLowStockProducts() {
  const { data } = await api.get('/inventory/low-stock')
  return data.data.products
}

/**
 * @param {number} [productId]
 * @returns {Promise<import('@/types/api').StockMovement[]>}
 */
export async function fetchStockMovements(productId) {
  const params = productId ? { product_id: productId } : {}
  const { data } = await api.get('/inventory/movements', { params })
  return data.data.movements
}

/**
 * @returns {Promise<import('@/types/api').StockAdjustmentReason[]>}
 */
export async function fetchAdjustmentReasons() {
  const { data } = await api.get('/inventory/adjustment-reasons')
  return data.data.reasons
}

/**
 * @param {{ product_id: number, quantity_delta: number, reason_id?: number | null, notes?: string }} payload
 */
export async function postStockAdjustment(payload) {
  const { data } = await api.post('/inventory/adjustments', payload)
  return data.data.movement
}

/**
 * @param {{ supplier_id?: number | null, notes?: string, lines: Array<{ product_id: number, quantity: number, unit_cost: number }> }} payload
 */
export async function createGoodsReceipt(payload) {
  const { data } = await api.post('/inventory/goods-receipts', payload)
  return data.data.goods_receipt
}

/**
 * @param {number} goodsReceiptId
 */
export async function postGoodsReceipt(goodsReceiptId) {
  const { data } = await api.post(`/inventory/goods-receipts/${goodsReceiptId}/post`)
  return data.data.goods_receipt
}

/**
 * @returns {Promise<import('@/types/api').GoodsReceipt[]>}
 */
export async function fetchGoodsReceipts() {
  const { data } = await api.get('/inventory/goods-receipts')
  return data.data.goods_receipts
}

/**
 * @param {{ notes?: string, lines: Array<{ product_id: number, counted_quantity: number }> }} payload
 */
export async function createStockTake(payload) {
  const { data } = await api.post('/inventory/stock-takes', payload)
  return data.data.stock_take
}

/**
 * @param {number} stockTakeId
 */
export async function postStockTake(stockTakeId) {
  const { data } = await api.post(`/inventory/stock-takes/${stockTakeId}/post`)
  return data.data.stock_take
}

/**
 * @returns {Promise<import('@/types/api').StockTake[]>}
 */
export async function fetchStockTakes() {
  const { data } = await api.get('/inventory/stock-takes')
  return data.data.stock_takes
}

/**
 * @param {{ product_id: number, quantity: number, supplier_id?: number | null, notes?: string }} payload
 */
export async function postPurchaseReturn(payload) {
  const { data } = await api.post('/inventory/purchase-returns', payload)
  return data.data.movement
}

/**
 * @param {{
 *   product_id: number,
 *   quantity: number,
 *   from_branch_id: number,
 *   to_branch_id: number,
 *   notes?: string,
 * }} payload
 */
export async function postStockTransfer(payload) {
  const { data } = await api.post('/inventory/transfers', payload)
  return data.data
}

/**
 * @param {{ product_id: number, quantity: number, notes?: string }} payload
 */
export async function postStockDamage(payload) {
  const { data } = await api.post('/inventory/damage', payload)
  return data.data.movement
}
